import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import mobileApplicationReleaseProfileService from '../../services/mobileApplicationReleaseProfileService';
import MobileApplicationReleaseProfileForm, {
  AGGREGATOR_COPY_DEFAULTS,
} from './MobileApplicationReleaseProfileForm';
import BuildApiKeyRevealDialog from './BuildApiKeyRevealDialog';

const defaultEntity = {
  id: 0,
  name: '',
  tenantId: null,
  deploymentMode: 0,
  tenantGroupId: null,
  appTitle: '',
  privacyPolicyUrl: '',
  deepLinkScheme: 'hermesz',
  deepLinkHost: 'app.hermesz.eu',
  enableParking: false,
  enableHtmlApplets: true,
  enableAnalytics: true,
  enableMap: true,
  mapTitle: 'Városi térkép',
  mapNavLabel: 'TÉRKÉP',
  officialsTitle: 'Vezetés',
  drawerFooterText: 'Modern Települések Program',
  ...AGGREGATOR_COPY_DEFAULTS,
  notes: '',
  applicationLabel: '',
  launcherIconId: null,
  adaptiveIconBackgroundColor: '#1A2543',
  splashBackgroundColor: '#1A2543',
  splashForegroundIconId: null,
  googleServicesJsonFileId: null,
  displayName: '',
  appIconId: null,
  launchScreenBackgroundColor: '#1A2543',
  googleServiceInfoPlistFileId: null,
};

const MobileApplicationReleaseProfileCreate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const [revealedKey, setRevealedKey] = useState('');
  const [keyDialogOpen, setKeyDialogOpen] = useState(false);
  const [createdProfileId, setCreatedProfileId] = useState<number | null>(null);
  const { canPlatform } = useCheckPermission();
  const canCreate = canPlatform(['ManageBuildProfiles']);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    mobileApplicationReleaseProfileService
      .create(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Profil létrehozva!', { variant: 'success' });
          if (response.result?.plainTextBuildApiKey) {
            setCreatedProfileId(response.result.profile?.id ?? null);
            setRevealedKey(response.result.plainTextBuildApiKey);
            setKeyDialogOpen(true);
          } else {
            navigate(
              `/mobileApplicationReleaseProfile/edit/${response.result.profile.id}`
            );
          }
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <>
      <MobileApplicationReleaseProfileForm
        entity={defaultEntity}
        readonly={!canCreate}
        onSubmit={onSubmit}
        errors={errors}
        handleCancel={() => navigate(-1)}
      />
      <BuildApiKeyRevealDialog
        open={keyDialogOpen}
        apiKey={revealedKey}
        onClose={() => {
          setKeyDialogOpen(false);
          setRevealedKey('');
          if (createdProfileId) {
            navigate(`/mobileApplicationReleaseProfile/edit/${createdProfileId}`);
          } else {
            navigate(-1);
          }
        }}
      />
    </>
  );
};

export default MobileApplicationReleaseProfileCreate;
